/** Keep in sync with `_one_hub_backend/src/casbin/normalizeAppManagementPermissions.js`. */

const SEMANTIC_APP_MANAGEMENT_KEYS = [
  "app_management:view_apps",
  "app_management:view_integrations",
  "app_management:add_integrations",
  "app_management:disconnect_integration",
];

const LEGACY_APP_MANAGEMENT_KEYS = [
  "app_management:view",
  "app_management:create",
  "app_management:update",
  "app_management:delete",
];

/**
 * @param {string[]} permissions
 * @returns {string[]}
 */
export function normalizeAppManagementPermissions(permissions) {
  const set = new Set((permissions || []).filter((p) => typeof p === "string" && p.trim()));

  if (set.has("app_management:view")) {
    set.add("app_management:view_apps");
    set.add("app_management:view_integrations");
    set.delete("app_management:view");
  }
  if (set.has("app_management:create") || set.has("app_management:update")) {
    set.add("app_management:add_integrations");
    set.delete("app_management:create");
    set.delete("app_management:update");
  }
  if (set.has("app_management:delete")) {
    set.add("app_management:disconnect_integration");
    set.delete("app_management:delete");
  }

  const hasSemantic = SEMANTIC_APP_MANAGEMENT_KEYS.some((k) => set.has(k));
  if (!hasSemantic) {
    for (const key of [...set]) {
      if (key.startsWith("app_management:")) {
        set.delete(key);
      }
    }
  } else {
    for (const key of LEGACY_APP_MANAGEMENT_KEYS) {
      set.delete(key);
    }
  }

  return [...set].sort();
}

/** @param {string} sectionId */
export function permissionModulePrefixForSection(sectionId) {
  if (sectionId === "app_management") return "app_management:";
  return null;
}
